import {makeStyles} from "@material-ui/core/styles";
import {Box, Grid, Icon, Popover, TextField, useTheme} from "@material-ui/core";
import lang from "../../core/lang";
import UserEvent from "../../core/UserEvent";
import i18n from "../../core/i18n";
import IconButton from "@material-ui/core/IconButton";
import PropTypes from "prop-types";
import React, {Fragment, useEffect} from "react";
import Button from "@material-ui/core/Button";
import Form from "../Form";

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: '0px',
        padding: '0',
    },
    label: {
        backgroundColor: props => props.backgroundColor,
        padding: '0.3em',
        borderRadius: '0px',
    }
}))

function LinkToolButton(props) {
    const {icon, style = {}, onClick, 'aria-label': ariaLabel} = props
    const theme = useTheme()
    const checked = lang.isFunction(props.checked) ? props.checked(props.value) : props.checked
    const backgroundColor = checked ? theme.palette.grey[300] : 'inherit'
    const classes = useStyles({backgroundColor})
    const [anchorEl, setAnchorEl] = React.useState(null)
    const [value, setValue] = React.useState()

    useEffect(() => {
        setValue(props.value)
    }, [props.value]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleChange = (event) => {
        setValue(event.value);
    }

    const handleConfirm = event => {
        onClick && onClick(new UserEvent({value}, event))
        setAnchorEl(null)
    }

    const handleCancel = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)
    const title = i18n.translate(props.title)

    const normalizedValue = lang.isString(value) ? {url: value, text: value} : value

    const url = normalizedValue?.url;
    const isUrl = !(lang.isEmpty(url) || lang.isUrl(url))

    return (
        <Fragment>
            <IconButton value={value} classes={classes} style={style} onClick={handleClick}
                        title={title} aria-label={i18n.translate(ariaLabel) || title} >
                <Icon fontSize="small" >{icon}</Icon>
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Form padding={2} minWidth={"18em"} maxWidth={"24em"} value={normalizedValue} onChange={handleChange}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField name="url" variant="outlined" size="small" fullWidth label={i18n.translate("Web Address")} onChange={handleChange} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField name="text" variant="outlined" size="small" fullWidth label={i18n.translate("Text to Display")} onChange={handleChange} />
                        </Grid>
                        <Grid item xs={6}>
                            <Button fullWidth size="small" variant="contained" color="primary" disabled={isUrl} onClick={handleConfirm}>{i18n.translate("Confirm")}</Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button fullWidth size="small" variant="contained" color="secondary" onClick={handleCancel}>{i18n.translate("Cancel")}</Button>
                        </Grid>
                    </Grid>
                </Form>
            </Popover>
        </Fragment>
    )
}

LinkToolButton.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            url: PropTypes.string,
            text: PropTypes.string,
        })
    ]),
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    style: PropTypes.object,
    onClick: PropTypes.func,
    title: PropTypes.string,
    'aria-label': PropTypes.string,
    checked: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.func
    ])
}

export default LinkToolButton